import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import ControlAmount from 'components/ControlAmount'
import { ResizeContext } from 'contexts/Resize'

import CartCostBlockNew from '../CartCostBlockNew'

import { CartProductBlock, DynamicImageStyled, CostBlock } from './styles'

/**
 * CartProduct
 *
 * @param {object} props - properties of component
 * @returns {node} CartProduct
 */
const CartProductNew = props => {
  const {
    boxes,
    currencyCode,
    dict,
    productInfo,
    productConfig,
    productType,
    handleIncrease,
    handleDecrease,
    toggleSubscription,
    intlCode,
    texts,
    isDisabled,
    isCartInitOrUpdate,
    precision,
    isControlsHidden,
    toggleModal,
  } = props
  const { isSubscription } = productInfo
  const { mobile } = useContext(ResizeContext)
  const handleIncreaseCurrent = () =>
    handleIncrease({
      productType,
      isSubscription: false,
    })
  const handleDecreaseCurrent = () =>
    handleDecrease({
      productType,
      isSubscription: false,
    })

  const imageContent = boxes ? (
    <DynamicImageStyled
      image={boxes}
      imageSizes={{ xs: 50, md: 103 }}
      imageType="png"
      alt=""
    />
  ) : null

  let descrBlockContent = isControlsHidden ? null : (
    <ControlAmount
      isActive={!isDisabled}
      amount={productInfo.amount}
      onMinusClick={handleDecreaseCurrent}
      onPlusClick={handleIncreaseCurrent}
      size={mobile ? 'small' : 'medium'}
    />
  )

  const rightBlockContent = (
    <CostBlock>
      <CartCostBlockNew
        key={`key-${intlCode}-${currencyCode}`}
        intlCode={intlCode}
        currencyCode={currencyCode}
        dictCart={texts}
        cost={productInfo.cost}
        realCost={productInfo.realCost}
        discount={productConfig.discount}
        precision={precision}
        showDiscount={productInfo.cost !== productInfo.realCost}
        showCrossedCost={
          !!productConfig.discount && productInfo.cost !== productInfo.realCost
        }
        isLoading={isCartInitOrUpdate}
        inRow={true}
        size="xs"
      />
    </CostBlock>
  )

  return (
    <>
      <CartProductBlock
        imageContent={imageContent}
        title={dict.kits[productType].title}
        subtitle={texts.products[productType].subtitle}
        descrBlockContent={descrBlockContent}
        rightBlockContent={rightBlockContent}
        alignByCenter={true}
        label={texts.special_offer}
        dict={dict}
        productType={productType}
        isDisabled={isDisabled}
        withSubscription={
          productConfig.subscription && productConfig.subscription.price
        }
        isSubscription={isSubscription}
        toggleSubscription={toggleSubscription}
        toggleModal={toggleModal}
      />
    </>
  )
}

CartProductNew.propTypes = {
  boxes: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  dict: PropTypes.object.isRequired,
  handleDecrease: PropTypes.func.isRequired,
  handleIncrease: PropTypes.func.isRequired,
  intlCode: PropTypes.string.isRequired,
  productConfig: PropTypes.object.isRequired,
  productInfo: PropTypes.object.isRequired,
  productType: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isCartInitOrUpdate: PropTypes.bool.isRequired,
  precision: PropTypes.number,
  isControlsHidden: PropTypes.bool,
  toggleSubscription: PropTypes.func,
  toggleModal: PropTypes.func,
}

CartProductNew.defaultProps = {
  isControlsHidden: false,
  isSpecial: false,
}

export default CartProductNew
